import { Optional } from '@infotech-soe/merps/types/common';
import {
  DisplayModeCallModel,
  DisplayModeName,
  TApplicationName,
  tg,
} from '@infotech-soe/metaschema';

export const getAppDisplayModeName = (
  application: TApplicationName | null,
  displayDefinition?: DisplayModeCallModel
): Optional<DisplayModeName> =>
  tg.isString(displayDefinition)
    ? displayDefinition
    : displayDefinition && application
      ? displayDefinition[application]
      : undefined;
